import { TCabinet } from "../types/cabinet";
import { appRequest, appRequestAbs } from "./services";

export const getMyCabinetsList = async (uid: string) => {
    const currentRequest = await appRequest<{
        data: Array<TCabinet>;
    }>({
        url: `cabinets?fields[0]=id&fields[1]=nom&fields[2]=uid&filters[status][$eq]=published&filters[users_permissions_user][uid][$eq]=${uid}`,
        // url: `cabinets?fields[0]=id&fields[1]=nom&fields[2]=uid&filters[status][$eq]=published`,
    });

    return currentRequest.data.data.map((item) => ({
        ...item,
    }));
};

export const getMyCabinetDetails = async (
    uid: string,
    cabinetId: string
): Promise<Array<TCabinet>> => {
    const currentRequest = await appRequest<{
        data: Array<any>;
    }>({
        url: `cabinets?populate=*&filters[status][$eq]=published&filters[users_permissions_user][uid][$eq]=${uid}&filters[uid][$eq]=${cabinetId}`,
        // url: `cabinets?populate=*&filters[status][$eq]=published&filters[uid][$eq]=${cabinetId}`,
    });

    return currentRequest.data.data.map((item) => {
        let images;

        if (item.images) {
            images = item.images.map((elm: any) => ({
                id: elm.id,
                filename: elm.name,
                url: elm.url,
            }));
        }

        return {
            ...item,
            departement: item.departement.data?.id,
            users_permissions_user: item.users_permissions_user.data?.id,
            logo: {
                id: item.logo?.id,
                filename: item.logo?.name,
                url: item.logo?.url,
            },
            id: item.id,
            images,
        };
    });
};

export const createCabinet = async (data: any) => {
    data.status = "published";
    const currentRequest = await appRequest<{
        data: TCabinet;
    }>({
        url: "cabinets?populate=*",
        method: "POST",
        data: { data },
    });

    return currentRequest.data;
};

export const updateCabinet = async (data: any) => {
    const idDoc = data.id;
    delete data.id;
    const currentRequest = await appRequest<{
        data: TCabinet;
    }>({
        url: `cabinets/${idDoc}?populate=*`,
        method: "PUT",
        data: { data },
    });

    return currentRequest.data;
};

export const deleteCabinet = async (id: string) => {
    const currentRequest = await appRequest<{
        data: { id: number; attributes: TCabinet };
    }>({
        url: `cabinets/${id}?populate=*`,
        method: "PUT",
        data: {
            data: {
                status: "deleted",
            },
        },
    });

    return currentRequest.data;
};

export const getLatLng = async (addresse: string) => {
    type TLatLon = {
        geometry: {
            coordinates: Array<number>;
        };
    };
    const currentRequest = await appRequestAbs<{
        data: { features: Array<TLatLon> };
    }>({
        url: `https://api-adresse.data.gouv.fr/search/?q=${encodeURI(
            addresse
        )}`,
    });

    const tFeatures = currentRequest.data.features;

    if (tFeatures.length === 0) {
        return null;
    }

    return {
        lon: tFeatures[0].geometry.coordinates[0],
        lat: tFeatures[0].geometry.coordinates[1],
    };
};
